import React, { useState, useRef } from 'react';
import "./PanelList.css";
import FormatAttribute from 'Components/FormatAttribute/FormatAttribute';
import MoneyMask from 'Components/MoneyMask/MoneyMask';
import NoDataFolder from "../../Components/SideBar/assets/icons/no-data-folder.png"
import doubleTapHandlers from 'Components/DoubleTap/doubleTapHandlers';

const PanelList = (
    { onUpdateIdSelected,
        idsSelected,
        list,
        children,
        onClickCell,
        onDoubleBlickCell,
        colorStyle,
        advanced,
        millisecondsBalloon,
        cursorCell,
        alternateColors = false,
        rowIndexSelected,
        defaultColorRow = 'white',
        alredyValidateQuery
    }) => {
    const [idShowBalloon, setIdShowBalloon] = useState(false);
    const balloonIdRef = useRef([]);

    const handleMouseOver = (key) => {
        if (!key || !millisecondsBalloon) {
            return false;
        }

        balloonIdRef.current.push(key);

        setTimeout(() => {
            if (balloonIdRef.current.length === 1 && balloonIdRef.current[0] === key) {
                setIdShowBalloon(key);
                balloonIdRef.current = [];
            }
        }, millisecondsBalloon);
    };

    const handleMouseOut = () => {
        balloonIdRef.current = [];
        setIdShowBalloon(null);
    };

    const handleCheckboxChange = (event, keyValidated) => {
        if (event.target.checked) {
            onUpdateIdSelected([...idsSelected, keyValidated]);
        } else {
            onUpdateIdSelected(idsSelected.filter(id => id !== keyValidated));
        }
    };

    function isCheckbox(key, idCheckbox) {
        return ((key && key.toUpperCase() === 'ID') || (idCheckbox && idCheckbox.toUpperCase() === 'ID')) && onUpdateIdSelected;
    }

    function getOnClickCell(keyValidated, monthValidated, currentMonth, index) {
        if (onClickCell) {
            return (() => onClickCell({ key: keyValidated, month: monthValidated, currentMonth: currentMonth, index: index }))
        } else {
            return (() => console.log('OnClick não implementado'))
        }
    }

    function getOnDoubleClickCell(keyValidated, monthValidated, currentMonth, index) {
        if (onDoubleBlickCell) {
            return (() => onDoubleBlickCell({ key: keyValidated, month: monthValidated, currentMonth: currentMonth, index: index }))
        } else {
            return (() => console.log('OnClick não implementado'))
        }
    }

    function getTypeData(key, index, valueToDisplay, colorItem, idCheckbox) {
        if (isCheckbox(key, idCheckbox)) {
            return (
                <input
                    type="checkbox"
                    id={`checkbox-users-id-${index}`}
                    className='checkbox-row-default'
                    onChange={(event) => handleCheckboxChange(event, valueToDisplay)}
                    checked={idsSelected.includes(valueToDisplay)}
                    style={{ cursor: 'pointer' }}
                />
            )
        } else if (colorItem === 'statusColor') {
            return colorStyle(valueToDisplay);
        } else {
            return (
                FormatAttribute.formatAttribute(valueToDisplay, null)
            )
        }
    }

    function styleRowPanelList(index, monthValidated) {
        if (null === rowIndexSelected && isSameMonthAndYear(monthValidated, new Date())) {
            return {
                backgroundColor: 'rgb(250 255 206 / 96%)',
                fontWeight: 'bold'
            };

        } else if (null != rowIndexSelected && index === rowIndexSelected) {
            return {
                backgroundColor: 'rgb(250 255 206 / 96%)',
                fontWeight: 'bold'
            };
        } else if (alternateColors) {
            return {
                backgroundColor: index % 2 === 0 ? 'rgb(250 250 250)' : 'white '
            };
        } else {
            return {
                backgroundColor: 'white'
            };
        }
    }

    function isSameMonthAndYear(date1, date2) {
        const d1 = new Date(date1);
        const d2 = new Date(date2);

        const isSameYear = d1.getUTCFullYear() === d2.getUTCFullYear();
        const isSameMonth = d1.getUTCMonth() === d2.getUTCMonth();

        return isSameYear && isSameMonth;
    }

    function getDivAttribute(column, key, index, row) {
        const element = row[key]
        const valueToDisplay = column.value
        const keyValidated = row[key].id
        const monthValidated = row[0].value
        const colorItem = column.dsField
        const currentMonth = column.currentMonth
        const color = column.color
        const idCheckbox = column.description
        const indexId = element.indexId
        const balloonValue = element.balloonValue
        let cursorCellById = ([1, 2, 3, 4, 5, 6].includes(indexId) || row[0].value === 'Total') ? 'context-menu' : cursorCell;

        return (
            <div className="cell-panel-list"
                key={indexId}
                style={{ color, cursor: cursorCellById }}
                onClick={getOnClickCell(keyValidated, monthValidated, currentMonth, index)}
                {...doubleTapHandlers(onDoubleBlickCell ? getOnDoubleClickCell(keyValidated, monthValidated, currentMonth, index) : null)}
                onMouseOver={() => handleMouseOver(indexId)}
                onMouseOut={() => handleMouseOut()}
            >
                {(idShowBalloon && balloonValue && idShowBalloon === indexId) && <div className="balloon-panel-list">{MoneyMask.validateMoneyMask(balloonValue)}</div>}
                {getTypeData(key, index, valueToDisplay, colorItem, idCheckbox)}
            </div>
        );
    }

    let rows
    if (list && list.length) {
        rows = list.map((row, index) => (
            <div className="user-row" key={index} style={styleRowPanelList(index, row[0].currentMonth)}>
                {Object.keys(row).map((key) => (
                    getDivAttribute(row[key], key, index, row)
                ))}
            </div>
        ));
    };

    let panel;
    if ((!list || list.length == 0) && alredyValidateQuery) {
        panel = (
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                height: '100%'
            }}>
                <img src={NoDataFolder} alt="Sem dados" style={{
                    width: '125px',
                    marginBottom: '20px'
                }} />
                <span style={{
                    fontSize: '1.2rem',
                    color: '#555'
                }}>Nenhum resultado encontrado.</span>
            </div>

        )
    } else {
        panel = (
            <div className="user-table">
                <div className="user-row header-spreadsheet">
                    {children}
                </div>
                {rows}
            </div>
        )
    }

    return (
        <>
            <div id='panel-list'>
                <div className="scrollable-content">
                    {panel}
                </div>
            </div>
        </>
    );
}

export default PanelList;
